"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Divider = _interopRequireDefault(require("../../Divider/Divider"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {};
/** Used to visually separate grouped Dropdown Items within a Dropdown Menu.
 * @visibleName Dropdown Divider
 * */

var DropdownDivider = function DropdownDivider(_ref) {
  var className = _ref.className;
  var componentClassNames = (0, _classnames.default)('rds-dropdown__divider', className);
  return /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: componentClassNames,
    spacing: "none"
  });
};

DropdownDivider.propTypes = propTypes;
DropdownDivider.defaultProps = defaultProps;
var _default = DropdownDivider;
exports.default = _default;